import React, { useState, useEffect } from "react";
import Header from "./header/header";
import Footer from "./Footer";
import "./Interviewprepcvreview.css";
import { ClipLoader } from "react-spinners";

const Interviewprepcvreview: React.FC = () => {
  const [ready, setReady] = useState(false);

  const toGmailsite = () => {
    window.open(
      "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info.academy@gmail.com",
      "_blank"
    );
  };

  const loadings = () => {
    new Promise((r) => setTimeout(r, 205));
    setReady(true);
  };

  useEffect(() => {
    loadings();
  }, []);

  return (
    <div>
      {ready ? (
        <>
          <Header />
          <div className="container">
            <br />
            <br />
            <br />
            <br />

            <div className="row">
              <div className="col-md-6">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <h3>Page not Available Yet. But Gbenga is;</h3>
                <p>
                  Gbenga is a Director who will be happy to meet you and discuss
                  your business needs. Message him at{" "}
                  <a
                    style={{ textDecoration: "none" }}
                    href="https://api.whatsapp.com/send?phone=37256704920"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="../../images/whatsapp.png"
                      style={{
                        marginRight: "10px",
                        marginLeft: "10px",
                        height: "20px",
                        display: "inline",
                      }}
                      alt="whatsap"
                    />
                    <span style={{ color: "#0000FF", cursor: "pointer" }}>
                      +372 5670 4920 +2347033416581
                    </span>
                    .
                  </a>
                </p>
                <p>
                  or you can email us through{" "}
                  <p
                    style={{
                      color: "#0000FF",
                      display: "inline",
                      cursor: "pointer",
                    }}
                    onClick={toGmailsite}
                  >
                    info.academy@gmail.com
                  </p>
                  .
                </p>

                <p>
                  But if you’re more interested in IT than in Gbenga, try the
                  links below:
                </p>
                <a href="/">Doyenify Home</a>
              </div>
              <div className="col-md-6 text-center">
                <br />

                <br />
                {/* <div className='caption-wrapper'>
                                <div className='img-wrapper'><img src="../../images/oluyide.jpg" alt="int"></img></div>
                                
                            </div> */}
                <img
                  src="../../images/oluyide.jpg"
                  alt="int"
                  style={{ width: "100%", borderRadius: "10px" }}
                ></img>
              </div>
            </div>

            <br />
            <br />
            <br />
          </div>
          <br />
          <br />

          <Footer />

          {/* <Header/>
                <div style={{zIndex: "100"}}>
                        <div className="headmid">

                        </div>

                        <div>
                          
                            <div >
                        
                                <div>
                                    <div className="row">
                                        
                                        <div className="col-md-8">
                                            <div className="setCenter">
                                                <h1  className="firstherotext">Interview Prep/CV Review</h1>
                                                <p className="secondherotext">Discover our engaging 'Hands-On Experience' service, 
                                                where participants learn and explore through active participation,
                                                 gaining practical skills and knowledge in an immersive and interactive environment</p>

                                                <button className="herobtn" 
                                                   
                                                >
                                                    Join the Programme
                                                </button>
                                               
                                            </div>
                                            
                                        </div>

                                        <div className="col-md-4">
                                            <div className="banimgpadsize">
                                                <img src="../../images/interviewprepcvreview.png" style={{width: "100%", marginTop: "70px", height: "400px", marginBottom: "30px"}} alt="heroim" />
                                            </div>
                                            
                                        </div>
                                       
                                        
                                    </div>
                                    
                                </div>
                                        
                                   
                                   
                              
                            </div>
                        </div>

                    </div>
                <div className="container" style={{marginTop: "70px"}} >
                    <h2 style={{textAlign: "center"}}>Please Drop your details here so we can reachout to You</h2>
                    <div className="row">
                        <div className="col-md-3">
                            
                        </div>
                        <div className="col-md-6">
                            <form className="secondhalfthird">
                                    
                                <div style={{marginBottom: "15px", marginTop: "15px"}}>
                                    <div style={{float: "left"}}>
                                        <p>Email</p>    
                                    </div>
                                    
                                        <input type="email" className="textinputsinterview" 
                                            required></input>
                                    
                                </div>
                                
                                <div style={{marginBottom: "20px"}}>
                                    <div style={{float: "left"}}>
                                        <p>Message</p>    
                                    </div>
                                    
                                    
                                    
                                    <textarea className="textinputsinterview2" placeholder="Your Message"
                                        required></textarea>
                                    
                                    
                                </div>
                                
                                
                                <div className="row">
                                    <div className="col-2">

                                    </div>
                                    <div className="col-8">
                                        <button type="submit" className="btn btn-success interviewbtn">Submit</button>
                                
                                    </div>
                                    <div className="col-2">
                                        
                                    </div>

                                </div>
                                
                            </form>
                        </div>
                        <div className="col-md-3">
                            
                        </div>
                    
                        
                    </div>
                    

                    <div className="container text-center" style={{marginTop: "50px"}}>
                                
                            <div className="row">
                                
                                
                                <div className="col">
                                    <img src="../../images/figma222.png"  alt="figma logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/react222.png"  alt="react logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/html222.png"  alt="html logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/cypress222.png"   alt="cypress logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/csharp222.png"  style={{width: "57px", height: "57px"}}  alt="csharp logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/node222.png"   alt="node logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/flutter222.png"   alt="flutter logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/css222.png"   alt="css logo"/>
                                </div>
                                <div className="col">
                                    <img src="../../images/javascript222.png"   alt="javascript logo"/>
                                </div>
                                
                                
                            </div>
                                
                        </div>
                <br/>
                    <br/>
                    <br/>
                    
                </div>
                
                <Footer /> */}
        </>
      ) : (
        <>
          <div>
            {/* <Audio
                        height="80"
                        width="80"
                        // radius="9"
                        color="green"
                        ariaLabel="loading"
                        wrapperStyle={{alignItems: "center", justifyContent: "center",verticalAlign: "middle", margin: "auto", position: "absolute",
                        top: "0", left: "0", bottom: "0", right: "0"}}
                        // wrapperClass
                        /> */}

            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Interviewprepcvreview;
